import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import {
  ActivityType,
  CompanyTableCustomizationService,
  ContactTableCustomizationService,
  CrmCoreModule,
  CrmFiltersService,
  CrmFormService,
  CrmObjectService,
  CrmTableStateService,
  CRMTrackingService,
  FieldOptionsInjectionToken as ModelDrivenFormFieldOptionsInjectionToken,
  modelDrivenFormFieldOptionsInjectionTokenGenerator,
  ObjectType,
  OpportunityTableCustomizationService,
  PageAnalyticsInjectionToken,
  pageAnalyticsInjectionTokenGenerator,
  RestrictedGroupService,
  tableFiltersInjectionTokenGenerator,
  TranslateByObjectTypeService,
  TranslateForCrmObjectService,
} from '@galaxy/crm/static';
import { GalaxyFilterChipInjectionToken } from '@vendasta/galaxy/filter/chips';
import { Routes } from '@angular/router';
import { ListTasksPageComponent } from '../../activity/task/list.component';

export const MULTI_LOCATION_TASK_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('../../activity/task/list.component').then((m) => m.ListTasksPageComponent),
    data: { objectType: 'activities' },
    pathMatch: 'full',
  },
];

const OBJECT_TYPE: ObjectType = 'Activity';
const ACTIVITY_TYPE: ActivityType = 'Task';

const CRM_PROVIDERS = [
  CompanyTableCustomizationService,
  ContactTableCustomizationService,
  CrmCoreModule,
  CrmFiltersService,
  CrmFormService,
  CrmObjectService,
  CrmTableStateService,
  CRMTrackingService,
  OpportunityTableCustomizationService,
  RestrictedGroupService,
  TranslateByObjectTypeService,
  TranslateForCrmObjectService,
];

@NgModule({
  declarations: [],
  imports: [CommonModule, TranslateModule, ListTasksPageComponent],
  providers: [
    ListTasksPageComponent,
    CommonModule,
    GalaxyPageModule,
    ...CRM_PROVIDERS,
    {
      provide: GalaxyFilterChipInjectionToken,
      useFactory: tableFiltersInjectionTokenGenerator(OBJECT_TYPE, ACTIVITY_TYPE),
    },
    {
      provide: ModelDrivenFormFieldOptionsInjectionToken,
      useFactory: modelDrivenFormFieldOptionsInjectionTokenGenerator(OBJECT_TYPE),
    },
    {
      provide: PageAnalyticsInjectionToken,
      useFactory: pageAnalyticsInjectionTokenGenerator(OBJECT_TYPE),
    },
  ],
})
export class BrandCRMTaskModule {}
